module.exports = __webpack_public_path__ + "img/rosso.8dccb661.png";